import { SFC } from "react";
import * as React from "react";
import "./LoadingGrid.css";

export const LoadingGrid: SFC<any> = () => {

  return (
    <div className="LoadingSpinner-grid">
      <div/>
      <div/>
      <div/>
      <div/>
      <div/>
      <div/>
      <div/>
      <div/>
      <div/>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/LoadingGrid.tsx